import type { Poll } from '@tunasong/schemas'
import { Transforms } from '@tunasong/plugin-lib'
import type { TunaEditor } from '@tunasong/plugin-lib'
import { Location } from 'slate'
import template from './template.js'

const insertBlock = (editor: TunaEditor, at?: Location, poll?: Poll) => {
  const node = poll ? poll : template

  Transforms.insertPersistedEntity(editor, node, { at })
}

export default insertBlock
